import React, { useState, useEffect } from 'react';

// Services
import { membershipStatuses } from 'services/constants';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// --------------------------------- SELECT MEMBERSHIP STATUSES --------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectMembershipStatuses = ({ statuses, setStatuses }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(membershipStatuses.map(s => ({ label: s.label, value: s.value })));
    }, []);

    return (
        <SelectMultiple
            value={statuses}
            onChange={value => setStatuses(value)}
            options={options}
            placeholder="Statut"
        />
    );
};

export default SelectMembershipStatuses;
